// Layouts
import TierRowsItem from "@/Layouts/components/Tiers/TierRowsItem";
import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";
import InputFormExtension from "@/Layouts/components/InputComponents/InputFormExtension";

// MUI
import { Stack } from "@mui/material";

// Types
import { IMatrixRowProps } from "./types";

const MAX_INPUT_UNITS = 1000;
const MAX_INPUT_DOLLARS = 1000000;

export default function MatrixRow(props: Readonly<IMatrixRowProps>) {
	const {
		index = 0,
		item = null,
		fromDisabled = false,
		toDisabled = false,
		spaces = {
			mainSection: 100,
			columns: 100,
			totalColumns: 1,
			totalRows: 1,
			separation: 5.5,
		},
		rowsErrors = [],
		columnsErrors = [],
		readOnly = false,
		spacing = "0.8",
		mainContentProps = null,
		sxMainContent = {
			minWidth: "190px",
		},
		cellsProps = {
			justifyContent: "center",
			alignItems: "center",
		},
		sxCells = {
			minWidth: "100px",
		},
		onActionUpdate = () => {},
		onChangeType = () => {},
	} = props;

	const hasOneBonusOnly = spaces?.totalColumns === 1 && spaces?.totalRows === 1;
	const INPUT_DEFINITION = {
		type: "Unit",
		min: -MAX_INPUT_UNITS,
		max: MAX_INPUT_UNITS,
		decimals: 2,
		decimalsEditable: true,
	};

	return (
		<TierRowsItem hasShadow={!(index % 2)} spaces={spaces}>
			<Stack direction={"row"} spacing={spacing}>
				<Stack {...mainContentProps} sx={{ ...sxMainContent }}>
					<DoubleInput
						firstInput={{
							data: [
								{
									...INPUT_DEFINITION,
									dashed: fromDisabled,
								},
							],
							sx: { width: "75px" },
							defaultType: item?.from?.input ?? "Unit",
							value: item?.from?.value ?? 0,
							error: Boolean(rowsErrors?.[index]?.from),
							disabled: fromDisabled,
							readOnly: true,
						}}
						secondInput={{
							data: [
								{
									...INPUT_DEFINITION,
									dashed: toDisabled,
								},
							],
							sx: { width: "75px" },
							defaultType: item?.to?.input ?? "Unit",
							value: item?.to?.value ?? 0,
							error: Boolean(rowsErrors?.[index]?.to),
							disabled: toDisabled,
							onActionUpdate: (value) => {
								onActionUpdate?.(index, 0, "row", "to", value);
							},
							readOnly,
						}}
					/>
				</Stack>
				<Stack direction={"row"} spacing={spacing}>
					{item?.bonuses?.map(
						(
							element: {
								bonus: {
									value: number;
									input: string;
								};
							},
							key: number
						) => {
							const indexKey = `bonuses_input_${key}`;
							return (
								<Stack key={indexKey} {...cellsProps} sx={sxCells}>
									<InputFormExtension
										data={[
											{
												type: "Percent",
												min: -100,
												max: 100,
												decimals: 2,
												decimalsEditable: true,
											},
											{
												type: "Dollar",
												min: -MAX_INPUT_DOLLARS,
												max: MAX_INPUT_DOLLARS,
												decimals: 2,
												decimalsEditable: false,
											},
											{
												type: "Dollar per Unit",
												min: -MAX_INPUT_UNITS,
												max: MAX_INPUT_UNITS,
												decimals: 2,
												decimalsEditable: true,
											},
										]}
										value={element?.bonus?.value || 0}
										defaultType={element?.bonus?.input || "Percent"}
										error={Boolean(columnsErrors?.[index]?.[key]?.["bonus"])}
										disabled={readOnly || hasOneBonusOnly}
										onChangeType={(_, input) => {
											onChangeType?.(index, key, "row", "bonus", input);
										}}
										onActionUpdate={(value) => {
											onActionUpdate?.(index, key, "row", "bonus", value);
										}}
										sx={{
											width: "95px",
										}}
									/>
								</Stack>
							);
						}
					)}
				</Stack>
			</Stack>
		</TierRowsItem>
	);
}
